export const pairs = [
  { question: { __html: "a moose" }, answer: { __html: "meese" } },
  { question: { __html: "beef" }, answer: { __html: "BEEF" } },
  { question: { __html: "a praying mantis" }, answer: { __html: "a cult" } },
  {
    question: { __html: "a yak" },
    answer: { __html: `yaks <span class="m-tiny">queen!</span>` },
  },
  {
    question: { __html: "an asparagus" },
    answer: { __html: "asparagallofus" },
  },
  { question: { __html: "a spaghetto" }, answer: { __html: "a spaslum" } },
  {
    question: { __html: "a passerby" },
    answer: { __html: `passers<span class="m-tiny">byeeeee</span>` },
  },
  { question: { __html: "a manatee" }, answer: { __html: "menatee" } },
  {
    question: { __html: "a goose" },
    answer: {
      __html: `*HONK* *HONK* *HONK*<br><span class="m-tiny">RUN!</span>`,
    },
  },
  {
    question: { __html: "cheese" },
    answer: { __html: "cheesemares" },
  },
  {
    question: { __html: "a hippopotamus" },
    answer: {
      __html: `hippopotOHMY<br><span class="m-tiny">THEY‘RE REALLY BIG</span>`,
    },
  },
  {
    question: { __html: "a mouse" },
    answer: { __html: "mouses" },
  },
  {
    question: { __html: "a house" },
    answer: { __html: "hice" },
  },
  {
    question: { __html: "a loaf" },
    answer: { __html: "bread" },
  },
  {
    question: { __html: "alumnus" },
    answer: { __html: "alumnallofus" },
  },
  {
    question: { __html: "a fish" },
    answer: { __html: "sushi" },
  },
  // {
  //   question: { __html: "a thesis" },
  //   answer: { __html: "thesi" },
  // },
  {
    question: { __html: "a larva" },
    answer: { __html: "OMG EW!" },
  },
  {
    question: { __html: "a tuna" },
    answer: { __html: "tunae" },
  },
  {
    question: { __html: "a bison" },
    answer: { __html: `<span class="m-tiny">joe</span> bisen` },
  },
  {
    question: { __html: "an ellipsis" },
    answer: { __html: "two ellipsare" },
  },
  // {
  //   question: { __html: "a crisis" },
  //   answer: { __html: `the<br>Middle East` },
  // },
  {
    question: { __html: "a stool" },
    answer: { __html: "feces" },
  },
  {
    question: { __html: "a sheep" },
    answer: { __html: "MMÄÄÄÄÄÄÄ" },
  },
  {
    question: { __html: "an ox" },
    answer: { __html: "MMÖÖÖÖÖÖ" },
  },
  {
    question: { __html: "a lasagna" },
    answer: { __html: "a food coma" },
  },
  {
    question: { __html: "a biceps" },
    answer: { __html: "triceps" },
  },
  {
    question: { __html: "a crow" },
    answer: { __html: "a murder of crows" },
  },
  {
    question: { __html: "an axe" },
    answer: { __html: "a murder of people" },
  },
  {
    question: { __html: "a tax" },
    answer: { __html: "the IRS" },
  },
  {
    question: { __html: "a volcano" },
    answer: { __html: "volcaNOPE" },
  },
  {
    question: { __html: "a bus" },
    answer: { __html: "ballofus" },
  },
];
